// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1TiPQ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__6SM8s"};